import React, { useEffect, useState } from "react";
import { DaumPostcode } from "../../../../../utils/DaumPostCode";
import * as R from "../../../../../css/PersonalSellingRequest/requestForm";
import { Form, Table } from "react-bootstrap";
// import getUserInfo from "../../../../../utils/hooks/getUserInfo";
import { postNumbaSelUserInfo } from "../../../../../api/auth";
import { toast } from "wc-toast";

export default function CommonRegistration(props) {
  const { buyReqData, setBuyReqData, buyingData, setUserTypeCd, isEdit } = props;
  const [isChecked, setIsChecked] = useState(!isEdit);
  const [userInfo, setUserInfo] = useState();
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  // console.log('comm buying isEdit',isEdit);
  // console.log('buyReqData',buyReqData);
  // console.log('buyingData',buyingData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBuyReqData({ ...buyReqData, [name]: value });
  };

  const handleCheckboxChange = async () => {
    setIsChecked(!isChecked);
    if (!isChecked) {
      setBuyReqData({
        ...buyReqData,
        user_nm: userInfo?.user_nm || "",
        phone: userInfo?.phone || "",
        corp_nm: userInfo?.corp_nm || "",
        zip: userInfo?.zip || "",
        addr1: userInfo?.addr1 || "",
        addr2: userInfo?.addr2 || "",
      });
    } else {
      setBuyReqData({
        ...buyReqData,
        user_nm: "",
        phone: "",
        corp_nm: "",
        zip: "",
        addr1: "",
        addr2: "",
      });
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (!file) return;
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error('지원되지 않는 파일 형식입니다. jpg, jpeg, png, pdf 파일만 업로드 가능합니다.');
      e.target.value = '';
      return;
    }

    if (file?.size > MAX_FILE_SIZE){
      toast.error('업로드할 수 없습니다. 파일 사이즈는 5MB 이하이어야 합니다.');
      e.target.value = '';
    } else {
      setBuyReqData({ ...buyReqData, [name]: file });
    }
  };

  const callUserInfo = async (buyingData) => {
    try {
      const response = await postNumbaSelUserInfo({});
      if (response.code === 1000) {
        //법인시
        // if (userInfo?.user_type_cd === 202) {
        //   setBuyReqData({ ...buyReqData, corp_nm: "" });
        // }
        if (isChecked) {
          setBuyReqData({
            ...buyingData,
            user_nm: response?.user_nm,
            phone: response?.phone,
            corp_nm: response?.corp_nm ?? "",
            zip: response?.zip,
            addr1: response?.addr1,
            addr2: response?.addr2 ?? "",
          });
        } 
        else if ((isEdit && buyingData.type === 2102) || (isEdit && buyingData.type === 2103)) {
          setBuyReqData({
            ...buyingData,
            ...buyingData[0],
          });
        }
        setUserTypeCd(response?.user_type_cd);
        setUserInfo(response);
      } else {
        console.log("유저정보 가져오기 실패");
      }
    } catch (err) {
      console.log("유저정보 가져오기 실패");
    }
  };

  useEffect(() => {
    if (buyingData && buyReqData) {
      callUserInfo(buyingData);
    }
  }, [buyingData]);

  // useEffect(() => {
  //   if ((isEdit && buyingData.type === 2102) || (isEdit && buyingData.type === 2103)) {
  //     setBuyReqData({
  //       ...buyingData,
  //       ...buyingData[0],
  //     });
  //   }
  // }, [buyingData]); 

  return (
    <div className="SecondSection">
      <div className="d-flex justify-content-between">
        <R.FormDetails_Heading>
          신청자 정보등록
        </R.FormDetails_Heading>
        <div>
          <Form.Check
            inline
            role="button"
            label="회원정보와 동일"
            name="group1"
            className="CustomCheckbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
        </div>
      </div>
      <R.FormDetails_Div>
        <div>
          {/* <Table bordered responsive className="table-form"> */}
          <Table bordered responsive>
            <tbody>
              <tr>
                <R.FormTable_Th width="25%">
                  {/* {buyReqData?.type === 2103 ? "임대" : "판매"}자 유형 */}
                  신청자 유형
                </R.FormTable_Th>
                <td colSpan={3}>
                  <div className="d-flex gap-2 gap-md-3 ms-chk">
                    <Form.Check
                      inline
                      label="법인"
                      name="userInfoType"
                      type="radio"
                      className="CustomCheckbox"
                      checked={userInfo?.user_type_cd === 202 && true}
                      readOnly
                    />
                    <Form.Check
                      inline
                      label="개인"
                      name="userInfoType"
                      type="radio"
                      className="CustomCheckbox"
                      readOnly
                      checked={userInfo?.user_type_cd === 201 && true}
                    />
                  </div>
                </td>
              </tr>

              {userInfo?.user_type_cd === 202 && (
                <tr>
                  <R.FormTable_Th>법인명</R.FormTable_Th>
                  <td colSpan={3}>
                    <R.Table_Input
                      // className="form-control Table_Inputx"
                      value={buyReqData?.corp_nm?.trim()}
                      name="corp_nm"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <R.FormTable_Th>
                  {/* {buyReqData?.type === 2103 ? "임대인 이름" : "판매자 이름"} */}
                  {/* {userInfo?.user_type_cd === 202
                    ? "담당자"
                    : buyReqData?.type === 2103
                    ? "임대인"
                    : "판매자"} */}
                  이름
                </R.FormTable_Th>
                <td colSpan={3}>
                  <R.Table_Input
                    // className="form-control Table_Inputx"
                    value={buyReqData?.user_nm?.trim()}
                    name="user_nm"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </td>
              </tr>
              <tr>
                <R.FormTable_Th>
                  {/* {buyReqData?.type === 2103 ? "임대인 " : "판매자 "} */}
                  {/* {userInfo?.user_type_cd === 202
                    ? "담당자"
                    : buyReqData?.type === 2103
                    ? "임대인"
                    : "판매자"} */}
                  휴대폰번호
                </R.FormTable_Th>
                <td colSpan={3}>
                  <R.Table_Input
                    // className="form-control Table_Inputx"
                    placeholder={"'-' 없이 입력"}
                    value={buyReqData?.phone?.replace(/[^0-9]/g, "")}
                    name={"phone"}
                    maxLength={11}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />                  
                </td>
              </tr>
              <tr>
                <R.FormTable_Th>
                  {/* {buyReqData?.type === 2103 ? "임대인 " : "판매자 "} */}
                  {/* {userInfo?.user_type_cd === 202
                    ? "법인회사"
                    : buyReqData?.type === 2103
                    ? "임대인"
                    : "판매자"} */}
                  주소
                </R.FormTable_Th>
                {/* <td colSpan={3} className="d-flex flex-column"> */}
                <td>
                  <div className="d-flex flex-column">
                    <div className="daum_search_wrapper">
                      <div className="d-flex w-100 mb-2">
                        <R.Table_Input
                          className="input-zip"
                          // width="120px"
                          name={"zip"}
                          value={buyReqData?.zip}
                          readOnly={true}
                        ></R.Table_Input>
                        <DaumPostcode
                          className="btn btn-primary btn-zip border-sm-1 h-md-46px h-sm-36px"
                          onCompleteCallback={(data) => {
                            setBuyReqData({
                              ...buyReqData,
                              zip: data.zonecode,
                              addr1: data.fullAddr,
                            });
                          }}
                        />
                      </div>
                      <R.TableInput_Search
                        width={"100%"}
                        name={"addr1"}
                        value={buyReqData?.addr1}
                        readOnly={true}
                        className="ms-0 mb-2 h-sm-36px"
                      ></R.TableInput_Search>
                    </div>
                    <R.TableInput_Search
                      width={"w-100"}
                      className={"h-sm-36px"}
                      name={"addr2"}
                      value={buyReqData?.addr2?.trim() ?? ''}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      placeholder={"상세 주소 입력 (선택)"}
                    ></R.TableInput_Search>
                  </div>
                </td>
              </tr>
              {buyReqData?.type === 2103 && (
                <tr>
                  <R.FormTable_Th>자동차등록증<br/>(선택)</R.FormTable_Th>
                  <td>
                    <div className="d-flex align-items-center ms-chk">
                      <label className="fileBtn" htmlFor="carFile">
                        파일선택
                      </label>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="carFile"
                        name="car_file"
                        onChange={(e) => handleFileSelect(e)}
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                      <div className="txt_attach ms-2">
                        {buyReqData?.car_file
                          ? buyReqData?.car_file?.name
                          : buyReqData?.car_file_nm}
                      </div>
                    </div>                    
                    <R.Btn_Value
                      className="d-lg-inline-block ms-chk"
                      color="#f60"
                    >
                      ※ 사진, 이미지, PDF 파일로 제출해주세요.&nbsp;<br/>
                    </R.Btn_Value>
                    <R.Btn_Value
                      className="d-lg-inline-block"
                      color="#8c8c8c"
                    >
                      (최대 5MB까지, jpg, jpeg, png, pdf만 가능)
                    </R.Btn_Value>
                  </td>
                </tr>
              )}
              {buyReqData?.type === 2103 && (
                <tr>
                  <R.FormTable_Th>화물운송종사<br/>자격증명서<br/>(선택)</R.FormTable_Th>
                  <td>
                    <div className="d-flex align-items-center ms-chk">
                      <label className="fileBtn" htmlFor="fw_file">
                        파일선택
                      </label>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="fw_file"
                        name="fw_file"
                        onChange={(e) => handleFileSelect(e)}
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                      <div className="txt_attach ms-2">
                        {buyReqData?.fw_file
                          ? buyReqData?.fw_file?.name
                          : buyReqData?.fw_file_nm}
                      </div>
                    </div>
                    <R.Btn_Value
                      className="d-lg-inline-block ms-chk"
                      color="#f60"
                    >
                      ※ 사진, 이미지, PDF 파일로 제출해주세요.&nbsp;<br/>
                    </R.Btn_Value>
                    <R.Btn_Value
                      className="d-lg-inline-block"
                      color="#8c8c8c"
                    >
                      (최대 5MB까지, jpg, jpeg, png, pdf만 가능)
                    </R.Btn_Value>
                  </td>
                </tr>
              )}
              <tr>
                <R.FormTable_Th>요청내용</R.FormTable_Th>
                <td>
                  <R.Table_Textarea
                    className="form-control form-textarea"
                    name="req_comment"
                    value={buyReqData?.req_comment}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  ></R.Table_Textarea>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </R.FormDetails_Div>
    </div>
  );
}
